module.exports = __webpack_public_path__ + "media/images/arrow-down-c5e8d3ef.png";